export const APM_WITH_SINGLE_ASSET_CLASS_SUBSTITUTION = {
	success: true,
	errors: [
		{
			code: 'MODEL_IS_OVERRIDDEN_AT_BLK',
			message: 'no',
			details: 'The model is imported in BLK'
		},
		{
			code: 'MODEL_IS_MODIFIED_AT_SOURCE',
			message: 'no',
			details: 'The model has been modified at source since its last import'
		},
		{
			code: 'MODEL_IS_A_FIRST_TIME_IMPORT',
			message: 'no',
			details: 'The model is imported for first time '
		}
	],
	status: 'OK',
	response: {
		id: 'apm3b41daee1-fcf2-4ee0-a562-af2a064fd58e',
		description: 'APM Dirty With Single Asset Class Substitution',
		type: 'PORTFOLIO',
		subType: 'THIRD_PARTY_MODEL',
		children: [
			{
				'identifier': 'PARTNER@0100000EOOP0112054100HYLTDKILVBOXI4FTRAE5NDRHYLK3ITGONSFDLY76BNSTWXBDBRB2A====',
				'identifierType': 'CUSTOM',
				'weight': 5,
				'allData': {
					'date': 1591341531349,
					'positionType': 'INVALID',
					'@type': '_bws.user.WebUserData',
					'description': 'Abbott Laboratories',
					'identifierType': 'CUSTOM',
					'type': 'PORTFOLIO_POSITION',
					'currentUserIsOwner': true,
					'score': 1,
					'dateCreated': 1591341531349,
					'dateLastModified': 1591341531349,
					'userEmail': 'ssangeet+123@bfm.com',
					'owner': { 'userPlatformId': '4279682', 'userEmail': 'ssangeet+123@bfm.com', 'userId': 'ssangeet+123@bfm.com' },
					'identifier': 'PARTNER@0100000EOOP0112054100HYLTDKILVBOXI4FTRAE5NDRHYLK3ITGONSFDLY76BNSTWXBDBRB2A====',
					'ticker': 'TLO.ABT',
					'trackingType': 'userData',
					'userPlatformId': '4279682',
					'childFlag': true,
					'level': 1,
					'updateUserId': 'ssangeet+123@bfm.com',
					'weight': 5,
					'userId': 'ssangeet+123@bfm.com',
					'updateTimestamp': 1591341531602,
					'parentId': '0e49f1e1-04fe-4a31-9a01-4dcb965d9f50',
					'parentType': 'PORTFOLIO',
					'otherIdentifiers': [
						{ 'identifier': 'TLO.ABT', '@type': '_bws.investments.IdentifierParam', 'identifierType': 'TICKER' },
						{
							'identifier': '0100000EOOP0112054100HYLTDKILVBOXI4FTRAE5NDRHYLK3ITGONSFDLY76BNSTWXBDBRB2A====',
							'customIdentifierType': 'ENVESTNET_HANDLE',
							'@type': '_bws.investments.IdentifierParam',
							'identifierType': 'CUSTOM'
						}
					],
					'originPlatform': { 'name': 'Abbott Laboratories', 'type': 'SECURITY' },
					'userTrackingId': '2626400',
					'uniqueId': '7e0b01f0-b9df-4d09-abe9-367de92b9bfc'
				}
			},
			{
				'identifier': 'IVV@464287200@US4642872000',
				'identifierType': 'SECURITY_ID',
				'weight': 35,
				'allData': {
					'date': 1591341531349,
					'positionType': 'VALID',
					'@type': '_bws.user.WebUserData',
					'description': 'iShares Core S&P 500 ETF',
					'identifierType': 'SECURITY_ID',
					'type': 'PORTFOLIO_POSITION',
					'currentUserIsOwner': true,
					'score': 1,
					'dateCreated': 1591341531349,
					'dateLastModified': 1591341531349,
					'userEmail': 'ssangeet+123@bfm.com',
					'commonIdentifier': 'IVV@464287200@US4642872000',
					'owner': { 'userPlatformId': '4279682', 'userEmail': 'ssangeet+123@bfm.com', 'userId': 'ssangeet+123@bfm.com' },
					'identifier': 'IVV@464287200@US4642872000',
					'ticker': 'IVV',
					'trackingType': 'userData',
					'userPlatformId': '4279682',
					'childFlag': true,
					'level': 1,
					'updateUserId': 'ssangeet+123@bfm.com',
					'weight': 35,
					'userId': 'ssangeet+123@bfm.com',
					'updateTimestamp': 1591341531602,
					'parentId': '0e49f1e1-04fe-4a31-9a01-4dcb965d9f50',
					'parentType': 'PORTFOLIO',
					'commonIdentifierType': 'SECURITY_ID',
					'otherIdentifiers': [
						{ 'identifier': 'IVV', '@type': '_bws.investments.IdentifierParam', 'identifierType': 'TICKER' },
						{ 'identifier': '464287200', '@type': '_bws.investments.IdentifierParam', 'identifierType': 'CUSIP' },
						{
							'identifier': '0100000EOOP01112384HALRLCGAKIKCDGTJB7XPGCQL5ZORZMN2EQCMAA32MZVFA7F4BGKMQ====',
							'customIdentifierType': 'ENVESTNET_HANDLE',
							'@type': '_bws.investments.IdentifierParam',
							'identifierType': 'CUSTOM'
						}
					],
					'originPlatform': { 'name': 'iShares Core S&P 500', 'type': 'SECURITY' },
					'userTrackingId': '2626400',
					'uniqueId': 'c834c80d-9c48-495a-9dcf-4efaee62d478'
				}
			},
			{
				'identifier': 'CASH-USD@XUSD00000@',
				'identifierType': 'SECURITY_ID',
				'weight': 5,
				'allData': {
					'date': 1591341531349,
					'positionType': 'VALID',
					'@type': '_bws.user.WebUserData',
					'description': 'UNITED STATES DOLLAR',
					'identifierType': 'SECURITY_ID',
					'type': 'PORTFOLIO_POSITION',
					'currentUserIsOwner': true,
					'score': 1,
					'dateCreated': 1591341531349,
					'dateLastModified': 1591341531349,
					'userEmail': 'ssangeet+123@bfm.com',
					'commonIdentifier': 'CASH-USD@XUSD00000@',
					'owner': { 'userPlatformId': '4279682', 'userEmail': 'ssangeet+123@bfm.com', 'userId': 'ssangeet+123@bfm.com' },
					'identifier': 'CASH-USD@XUSD00000@',
					'ticker': 'CASH-USD',
					'trackingType': 'userData',
					'userPlatformId': '4279682',
					'childFlag': true,
					'level': 1,
					'updateUserId': 'ssangeet+123@bfm.com',
					'weight': 5,
					'userId': 'ssangeet+123@bfm.com',
					'updateTimestamp': 1591341531602,
					'parentId': '0e49f1e1-04fe-4a31-9a01-4dcb965d9f50',
					'parentType': 'PORTFOLIO',
					'commonIdentifierType': 'SECURITY_ID',
					'otherIdentifiers': [
						{
							'identifier': '0100000EOOP01154570HDJVOR3B324GYREVXOV43K3O5475D4Q2LGBQ3HJO7C4B2KE56YTSQ====',
							'customIdentifierType': 'ENVESTNET_HANDLE',
							'@type': '_bws.investments.IdentifierParam',
							'identifierType': 'CUSTOM'
						},
						{ 'identifier': 'CASH-USD', '@type': '_bws.investments.IdentifierParam', 'identifierType': 'TICKER' },
						{ 'identifier': 'CASH-USD', '@type': '_bws.investments.IdentifierParam', 'identifierType': 'CUSIP' }
					],
					'originPlatform': { 'name': 'Cash', 'type': 'ASSET_CLASS' },
					'userTrackingId': '2626400',
					'uniqueId': 'cedeff54-0e9b-47fc-8a1a-3f463bec30b0'
				}
			},
			{
				'identifier': 'ISTB@46432F859@US46432F8591',
				'identifierType': 'SECURITY_ID',
				'weight': 5,
				'allData': {
					'date': 1591341531349,
					'positionType': 'SUBSTITUTED',
					'@type': '_bws.user.WebUserData',
					'description': 'iShares Core 1-5 Year USD Bond ETF',
					'identifierType': 'SECURITY_ID',
					'type': 'PORTFOLIO_POSITION',
					'currentUserIsOwner': true,
					'score': 1,
					'mappedFrom': ['PARTNER@0100000EOOP01154587HDJVOR3B324GYREVXOV43K3O545PS3UTD5Z5DOSYCDWC365JSLZQA===='],
					'dateCreated': 1591341531349,
					'dateLastModified': 1591341531349,
					'userEmail': 'ssangeet+123@bfm.com',
					'commonIdentifier': 'ISTB@46432F859@US46432F8591',
					'owner': { 'userPlatformId': '4279682', 'userEmail': 'ssangeet+123@bfm.com', 'userId': 'ssangeet+123@bfm.com' },
					'identifier': 'ISTB@46432F859@US46432F8591',
					'ticker': 'ISTB',
					'trackingType': 'userData',
					'userPlatformId': '4279682',
					'childFlag': true,
					'level': 1,
					'updateUserId': 'ssangeet+123@bfm.com',
					'weight': 5,
					'userId': 'ssangeet+123@bfm.com',
					'updateTimestamp': 1591341531601,
					'parentId': '0e49f1e1-04fe-4a31-9a01-4dcb965d9f50',
					'parentType': 'PORTFOLIO',
					'commonIdentifierType': 'SECURITY_ID',
					'userTrackingId': '2626400',
					'uniqueId': '4bf9f507-d5f9-4a9b-9e75-d32fdb5f9c82'
				}
			},
			{
				'identifier': 'PARTNER@0100000EOOP0112058551HYLTDKILVBOXI4FTRAE5NDRHYLJSY55MU2WXBZGYUZL4RDYMHKOMQ====',
				'identifierType': 'CUSTOM',
				'weight': 5,
				'allData': {
					'date': 1591341531349,
					'positionType': 'INVALID',
					'@type': '_bws.user.WebUserData',
					'description': '3D Systems Corp',
					'identifierType': 'CUSTOM',
					'type': 'PORTFOLIO_POSITION',
					'currentUserIsOwner': true,
					'score': 1,
					'dateCreated': 1591341531349,
					'dateLastModified': 1591341531349,
					'userEmail': 'ssangeet+123@bfm.com',
					'owner': { 'userPlatformId': '4279682', 'userEmail': 'ssangeet+123@bfm.com', 'userId': 'ssangeet+123@bfm.com' },
					'identifier': 'PARTNER@0100000EOOP0112058551HYLTDKILVBOXI4FTRAE5NDRHYLJSY55MU2WXBZGYUZL4RDYMHKOMQ====',
					'ticker': 'TLO.DDD',
					'trackingType': 'userData',
					'userPlatformId': '4279682',
					'childFlag': true,
					'level': 1,
					'updateUserId': 'ssangeet+123@bfm.com',
					'weight': 5,
					'userId': 'ssangeet+123@bfm.com',
					'updateTimestamp': 1591341531601,
					'parentId': '0e49f1e1-04fe-4a31-9a01-4dcb965d9f50',
					'parentType': 'PORTFOLIO',
					'otherIdentifiers': [
						{
							'identifier': '0100000EOOP0112058551HYLTDKILVBOXI4FTRAE5NDRHYLJSY55MU2WXBZGYUZL4RDYMHKOMQ====',
							'customIdentifierType': 'ENVESTNET_HANDLE',
							'@type': '_bws.investments.IdentifierParam',
							'identifierType': 'CUSTOM'
						},
						{ 'identifier': 'TLO.DDD', '@type': '_bws.investments.IdentifierParam', 'identifierType': 'TICKER' }
					],
					'originPlatform': { 'name': '3D Systems Corp', 'type': 'SECURITY' },
					'userTrackingId': '2626400',
					'uniqueId': '841fe357-0259-4691-917d-88abdf523592'
				}
			},
			{
				'identifier': 'PARTNER@0100000EOOP01154587HDJVOR3B324GYREVXOV43K3O545PS3UTD5Z5DOSYCDWC365JSLZQA====',
				'identifierType': 'CUSTOM',
				'weight': 5,
				'allData': {
					'date': 1591341531349,
					'positionType': 'INVALID',
					'@type': '_bws.user.WebUserData',
					'description': 'Short Bond',
					'identifierType': 'CUSTOM',
					'type': 'PORTFOLIO_POSITION',
					'currentUserIsOwner': true,
					'score': 1,
					'dateCreated': 1591341531349,
					'dateLastModified': 1591341531349,
					'userEmail': 'ssangeet+123@bfm.com',
					'owner': { 'userPlatformId': '4279682', 'userEmail': 'ssangeet+123@bfm.com', 'userId': 'ssangeet+123@bfm.com' },
					'identifier': 'PARTNER@0100000EOOP01154587HDJVOR3B324GYREVXOV43K3O545PS3UTD5Z5DOSYCDWC365JSLZQA====',
					'ticker': 'BD-ST',
					'trackingType': 'userData',
					'userPlatformId': '4279682',
					'childFlag': true,
					'level': 1,
					'updateUserId': 'ssangeet+123@bfm.com',
					'weight': 5,
					'userId': 'ssangeet+123@bfm.com',
					'updateTimestamp': 1591341531601,
					'parentId': '0e49f1e1-04fe-4a31-9a01-4dcb965d9f50',
					'parentType': 'PORTFOLIO',
					'otherIdentifiers': [
						{
							'identifier': '0100000EOOP01154587HDJVOR3B324GYREVXOV43K3O545PS3UTD5Z5DOSYCDWC365JSLZQA====',
							'customIdentifierType': 'ENVESTNET_HANDLE',
							'@type': '_bws.investments.IdentifierParam',
							'identifierType': 'CUSTOM'
						},
						{ 'identifier': 'BD-ST', '@type': '_bws.investments.IdentifierParam', 'identifierType': 'TICKER' }
					],
					'originPlatform': { 'name': 'Short Bond', 'type': 'ASSET_CLASS' },
					'userTrackingId': '2626400',
					'uniqueId': 'adb26941-47e8-4439-a15e-ef119c78e047'
				}
			},
			{
				'identifier': 'WOOD@464288174@US4642881746',
				'identifierType': 'SECURITY_ID',
				'weight': 5,
				'allData': {
					'date': 1591341531349,
					'positionType': 'VALID',
					'@type': '_bws.user.WebUserData',
					'description': 'iShares Global Timber & Forestry ETF',
					'identifierType': 'SECURITY_ID',
					'type': 'PORTFOLIO_POSITION',
					'currentUserIsOwner': true,
					'score': 1,
					'dateCreated': 1591341531349,
					'dateLastModified': 1591341531349,
					'userEmail': 'ssangeet+123@bfm.com',
					'commonIdentifier': 'WOOD@464288174@US4642881746',
					'owner': { 'userPlatformId': '4279682', 'userEmail': 'ssangeet+123@bfm.com', 'userId': 'ssangeet+123@bfm.com' },
					'identifier': 'WOOD@464288174@US4642881746',
					'ticker': 'WOOD',
					'trackingType': 'userData',
					'userPlatformId': '4279682',
					'childFlag': true,
					'level': 1,
					'updateUserId': 'ssangeet+123@bfm.com',
					'weight': 5,
					'userId': 'ssangeet+123@bfm.com',
					'updateTimestamp': 1591341531601,
					'parentId': '0e49f1e1-04fe-4a31-9a01-4dcb965d9f50',
					'parentType': 'PORTFOLIO',
					'commonIdentifierType': 'SECURITY_ID',
					'otherIdentifiers': [
						{ 'identifier': '464288174', '@type': '_bws.investments.IdentifierParam', 'identifierType': 'CUSIP' },
						{ 'identifier': 'WOOD', '@type': '_bws.investments.IdentifierParam', 'identifierType': 'TICKER' },
						{
							'identifier': '0100000EOOP011192576H2KVB52BC6H5VJHIQ5VSNLZTAQITOGGPHRKD2KTJAAOITJUSGBK3A====',
							'customIdentifierType': 'ENVESTNET_HANDLE',
							'@type': '_bws.investments.IdentifierParam',
							'identifierType': 'CUSTOM'
						}
					],
					'originPlatform': { 'name': 'iShares Global Timber & Forestry ETF', 'type': 'SECURITY' },
					'userTrackingId': '2626400',
					'uniqueId': 'fbe47ab4-50b7-4055-8caf-cfb9fcdef0f4'
				}
			}
		],
		allData: {
			date: 1589457125381,
			'@type': 'com.bfm.webtools.api.domain.user.WebUserData',
			origin: 'partner',
			flags: {
				originContainsEditableModel: true,
				firstTimeImport: true,
				inputWithValues: false,
				isProcessed: false,
				originSleeveContainsUnmatchedSecurities: false,
				'originContainsReallocatedSecurities': false,
				'originIsfirstTimeImported': true,
				'originContainsUnsupportedManagedModel': false,
				'originContainsFixedIncomeSubstitutions': false,
				'containsChildrenPortfolios': false,
				'originContainsFlattenedSleeves': false,
				'originContainsUnmatchedSecurities': true,
				'originContainsAssetClassSubstitutions': true,
				'originContainsSleeves': false
			},
			description: 'APM Dirty With Sleeve DP',
			type: 'PORTFOLIO',
			currentUserIsOwner: true,
			score: 1,
			parentFlag: true,
			dateCreated: 1589457125381,
			dateLastModified: 1589457125381,
			userEmail: 'rrandall@bfm.com',
			perms: {
				DELETE: [
					'webUserDataPerm@AdvisorPort'
				],
				SHARE: [
					'webUserDataPerm@AdvisorPort'
				],
				VIEW: [
					'webUserDataPerm@AdvisorPort'
				]
			},
			owner: {
				userPlatformId: '3225081',
				userEmail: 'rrandall@bfm.com',
				userId: 'rrandall@bfm.com'
			},
			ssoIdp: 'envestnet',
			toolOrigin: 'partner',
			trackingType: 'userData',
			userPlatformId: '3225081',
			level: 0,
			updateUserId: 'rrandall@bfm.com',
			childCount: 3,
			userId: 'rrandall@bfm.com',
			updateTimestamp: 1589457125613,
			otherIdentifiers: [
				{
					identifier: 'apm3b41daee1-fcf2-4ee0-a562-af2a064fd58e',
					customIdentifierType: 'ENVESTNET_HANDLE',
					'@type': '_bws.investments.IdentifierParam',
					identifierType: 'CUSTOM'
				}
			],
			subType: 'THIRD_PARTY_MODEL',
			originPlatform: {
				firm: 'BlackRock',
				dateImported: '1589457125357',
				programHandle: '0100000EEEN01613HTERU5ACK7K7LVH4SCFH27PYMT7DJGMUVG3XAIJDRRANTIEIPDECA====',
				portfolioType: 'ADVISOR_MODEL',
				externalModelDateLastModified: '1589456813147',
				riskHandle: '0100000EOOP03319HHDGRBCT6R5HKSEOM7SVAPCF42QESC7I5246T3UHHCE5X5YGWBATQ====',
				platform: 'ENVESTNET'
			},
			userTrackingId: '2555854',
			uniqueId: 'apm3b41daee1-fcf2-4ee0-a562-af2a064fd58e',
			applications: [
				'partner',
				'bfa'
			]
		}
	},
	responseTimes: {
		root: {
			nodes: [
				{
					data: {
						getModelDetails: 1.242
					},
					nodes: [
						{
							data: {
								accessToken: 0
							}
						},
						{
							data: {
								searchPortfolio: 0.411
							},
							nodes: [
								{
									data: {
										searchPortfolio: 0.405
									}
								}
							]
						},
						{
							data: {
								getPortfolioJson: 0.391
							},
							nodes: [
								{
									data: {
										getPortfolioJson: 0.208
									}
								}
							]
						}
					]
				}
			]
		}
	}
};

